import { apiRequest } from '../../lib/api';
import {
  adminUsersSchema,
  messagesSchema,
  notificationsSchema,
  okSchema,
} from '../../lib/schemas';

export const getMessages = () => apiRequest('/api/messages', messagesSchema);
export const getAdminUsers = ({ signal }: { signal?: AbortSignal } = {}) => apiRequest('/api/admin/users', adminUsersSchema, signal ? { signal } : {});
export const getNotifications = () => apiRequest('/api/notifications', notificationsSchema);

export const markNotificationsRead = () => apiRequest('/api/notifications/read', okSchema, {
  method: 'POST',
  body: '{}',
});

export const sendNotification = (body: string, toUserId?: number) => apiRequest('/api/notifications', okSchema, {
  method: 'POST',
  body: JSON.stringify(toUserId ? { body, toUserId } : { body }),
});
